export function getImages(data) {
  return {
    getFile(name, alias = "allFile") {
      let file = data[alias]?.edges?.find((image) =>
        image.node.base.split(".").includes(name),
      );

      if (file) {
        return file.node?.childImageSharp;
      }

      return data[name]?.childImageSharp;
    },
  };
}
